import {
  channelRenderHelper,
  countryRenderHelper,
} from '@op/pages/download/renderHelper';
import { DownloadConfigInfoType } from '@op/pages/download/types';
import { DEFAULT_METRICS } from '@opm/pages/Videos/constants';
import {
  getDouyinVideoList,
  getVideoTableList,
  getXVideoList,
} from '@opm/services';

export const MarketingVideoDownload: DownloadConfigInfoType = {
  type: 'page',
  downloadFunc: params => {
    return getVideoTableList({ data: params });
  },
  columns: () => {
    return [
      { key: 'video_title', header: 'Video Title(Origin)' },
      { key: 'video_title_en', header: 'Video Title(English)' },
      { key: 'video_title_zh', header: 'Video Title(Chinese)' },
      { key: 'anchor_name', header: 'Author' },
      {
        key: 'channel_name',
        header: 'Channel',
        renderHelper: [channelRenderHelper],
      },
      { key: 'video_url', header: 'URL' },
      { key: 'video_release_time', header: 'Release Time' },
      {
        key: 'country',
        header: 'Country',
        renderHelper: [countryRenderHelper],
      },
      { key: 'tweets_view', header: 'Views' },
      { key: 'engagement', header: 'Engagement' },
      { key: 'tweets_like', header: 'Likes' },
    ];
  },
};

export const MarketingVideoXDownload: DownloadConfigInfoType = {
  type: 'page',
  customizeDownloadFunc: async ({ filter, auxiliaryParams }) => {
    const { channel } = auxiliaryParams;
    const data = await getXVideoList({ data: filter });
    return {
      ...(data || {}),
      list: data?.list?.map((it: any) => ({
        ...(it || {}),
        channel_name: channel,
      })),
    };
  },
  columns: () => {
    return [
      { key: 'content_text', header: 'Video Content(Origin)' },
      { key: 'content_text_en', header: 'Video Content(English)' },
      { key: 'content_text_zh', header: 'Video Content(Chinese)' },
      { key: 'author_name', header: 'Author' },
      {
        key: 'channel_name',
        header: 'Channel',
        renderHelper: [channelRenderHelper],
      },
      { key: 'post_url', header: 'URL' },
      { key: 'publish_time', header: 'Publish Time' },
      {
        key: 'country',
        header: 'Country',
        renderHelper: [countryRenderHelper],
      },
      {
        key: 'category',
        header: 'Category(English)',
        renderHelper: [countryRenderHelper],
      },
      {
        key: 'category_zh',
        header: 'Category(Chinese)',
      },
      ...DEFAULT_METRICS.map(item => {
        return {
          key: item.key,
          header: item.label,
        };
      }),
    ];
  },
};

export const MarketingDouyinVideoDownload: DownloadConfigInfoType = {
  type: 'page',
  downloadFunc: params => {
    return getDouyinVideoList({ data: params });
  },
  columns: () => {
    return [
      { key: 'video_title', header: 'Video Title(Origin)' },
      { key: 'video_title_en', header: 'Video Title(English)' },
      { key: 'video_title_zh', header: 'Video Title(Chinese)' },
      { key: 'author_name', header: 'Author' },
      { key: 'video_url', header: 'URL' },
      { key: 'publish_time', header: 'Release Time' },
      { key: 'view_count', header: 'Views' },
      { key: 'like_count', header: 'Likes' },
      { key: 'share_count', header: 'Shares' },
      { key: 'comment_count', header: 'Comments' },
    ];
  },
};
